
// Unit conversion helpers
export const cmToInches = (cm: number): number => {
  return cm * 0.393701;
};

export const inchesToCm = (inches: number): number => {
  return inches * 2.54;
};

export const gToLb = (g: number): number => {
  return g * 0.00220462;
};

export const lbToG = (lb: number): number => {
  return lb * 453.592;
};
